import { StringStore } from "StringStore";
import "./description-container.scss";
import EquilibreRatioImg from "assets/profile/equilibreRatioImg.jpg";
import ModereRatioImg from "assets/profile/modereRatioImg.jpg";
import DynamicRatioImg from "assets/profile/dynamicRatioImg.jpg";
import { useDispatch, useSelector } from "react-redux";
import { getDescripton } from "features/profile/profileSlices";
import { useEffect, useMemo } from "react";
import { textFormatter } from "utils/fileFormatter";

const DescriptionContainer = () => {
  const dispatch: Function = useDispatch();
  const currentProfile = useSelector(
    (state: any) => state.profile.currentProfile
  );
  const description = useSelector((state: any) => state.profile.description);
  const formattedDescription = textFormatter(description);
  const imageByProfileType = useMemo(() => {
    switch (currentProfile.type) {
      case "Dynamique":
        return DynamicRatioImg;
      case "Equilibré":
        return EquilibreRatioImg;
      case "Modéré":
        return ModereRatioImg;
      default:
        return "";
    }
  }, [currentProfile.type]);

  useEffect(() => {
    dispatch(getDescripton(currentProfile.code));
  }, [currentProfile.code]);

  return (
    <div className="desc-container">
      <div className="desc-container__explanation">
        <div className="desc-container__explanation__title">
          {StringStore.profile.explanationTitle}
        </div>
        <p
          className="desc-container__explanation__text"
          dangerouslySetInnerHTML={{ __html: formattedDescription }}
        ></p>
      </div>
      <div className="desc-container__ratio">
        <div className="desc-container__ratio__title">
          {StringStore.profile.ratioTitle}
        </div>
        <img
          src={imageByProfileType}
          alt="Logo"
          className="desc-container__ratio__logo"
        />
      </div>
    </div>
  );
};

export default DescriptionContainer;
